module.exports = __webpack_public_path__ + "img/Повреждение менисков, связок, хряща.e50ba565.jpg";